import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';

interface Separator {
    UID: string;
    url: string;
}




@Injectable()
export class SeparatorServices {
    public db: any;
    separatorsCol: AngularFirestoreCollection<Separator>;
    separators: Observable<Separator[]>;

    constructor(public afs: AngularFirestore) {
        this.db = firebase.firestore();
    }

    getList() {
        this.separatorsCol = this.afs.collection('separators');
        this.separators = this.separatorsCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Separator;
                data.UID = a.payload.doc.id;
                return data;
            });
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/services/separators.ts